module.exports = __webpack_public_path__ + "static/palm_tree_01-12743ed760f4dfec7a4e32bc50793fba.png";